import React from "react";
import { useTranslation } from "react-i18next";

import { Props } from "./types";
import { ArrowIcon } from "./arrowIcon";
import styles from "./styles.scss";

function MoveToTodayButton({ move }: Props) {
  const { t } = useTranslation();

  return (
    <button className={styles.moveToTodayButton} onClick={move}>
      <ArrowIcon className={styles.icon} />
      <p className={styles.text}>{t("projectPage.ganttPage.moveToToday")}</p>
    </button>
  );
}

export { MoveToTodayButton };
